/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'notFound.pageTitle',
    defaultMessage: 'Not found',
  },
  title: {
    id: 'notFound.title',
    defaultMessage: 'Error: 404',
  },
});
